import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { FaRupeeSign } from "react-icons/fa";
import { useAppDispatch } from "../../app/hooks";
import { clearWalletIndex } from "./walletSlice";
import { createPaymentOrder } from "../reviewbooking/services/reviewbooking.services";
import moment from "moment";
import {
  getWalletBalance,
  insertTempWalletBalance,
  verifyWalletAmount,
} from "./services/wallet.services";
import { ErrorToast } from "../../toast/Toasts";
import { IoMdCloseCircleOutline } from "react-icons/io";

const AddBalance = () => {
  const dispatch = useAppDispatch();

  const formik = useFormik({
    initialValues: {
      amount: 0,
    },
    validationSchema: Yup.object({
      amount: Yup.number()
        .required("Amount is required")
        .min(1, "Minimum amount is ₹1")
        // .min(100, "Minimum amount is ₹100")
        .max(100000, "Maximum amount is ₹1,00,000"),
    }),
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      try {
        const tempRes = await dispatch(
          insertTempWalletBalance({
            Amount: values.amount,
            UserID: localStorage.getItem("user_id"),
          })
        );

        if (
          tempRes?.meta.requestStatus === "fulfilled" &&
          tempRes.payload?.Data?.ID
        ) {
          const orderResponse: any = await dispatch(
            createPaymentOrder({
              Amount: Math.floor(values.amount * 100),
              Currency: "INR",
            })
          );

          const orderDetails = orderResponse?.payload?.Data;
          const options = {
            key: process.env.REACT_APP_RAZORPAY_KEY_ID,
            amount: orderDetails?.Amount,
            currency: orderDetails?.Currency,
            name: "BIGSMILE HOLIDAYS PRIVATE LIMITED",
            description: `transction_add_balance_${localStorage.getItem(
              "user_guid"
            )}${moment().format("YYYY-MM-DD:HH:mm:ss")}`,
            order_id: orderDetails?.Orderid,
            // retry: { enabled: false },
            handler: async function (response: any) {
              const orderDetails: any = await dispatch(
                verifyWalletAmount({
                  RazorpayOrderId: response.razorpay_order_id,
                  RazorpayPaymentId: response.razorpay_payment_id,
                  RazorpaySignature: response.razorpay_signature,
                  transaction_wallet_id: tempRes.payload?.Data?.ID,
                })
              );

              if (orderDetails?.meta?.requestStatus === "fulfilled") {
                dispatch(clearWalletIndex());
                dispatch(getWalletBalance());
              } else {
                console.error("Payment verification failed:", orderDetails);
              }
            },
            theme: {
              color: "green",
            },
          };

          const rzp = new window.Razorpay(options);
          rzp.open();

          rzp.on("payment.failed", function (response: any) {
            ErrorToast(response.error.description);
            console.error("Payment failed", response);
          });
        }
      } catch (error) {
        console.error("Payment failed:", error);
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <div className="row mt-3">
      <div className="col-12 wallet-main-card">
        <div className="d-flex justify-content-between">
          <h4>Add Balance</h4>
          <IoMdCloseCircleOutline
            className="fs-3 cursor-pointer"
            onClick={() => dispatch(clearWalletIndex())}
          />
        </div>
        <div className="mt-4">
          <form onSubmit={formik.handleSubmit}>
            <div className="row">
              <div className="col-md-6">
                <div className="field">
                  <label
                    className={
                      formik.touched.amount && formik.errors.amount
                        ? "error-label fs-6"
                        : "fs-6"
                    }
                  >
                    Amount <code>*</code>
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <FaRupeeSign />
                    </span>
                    <input
                      type="number"
                      name="amount"
                      className={`form-control ${
                        formik.touched.amount && formik.errors.amount
                          ? "error-border"
                          : ""
                      }`}
                      placeholder="Enter amount"
                      value={formik.values.amount}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </div>
                  {formik.touched.amount && formik.errors.amount && (
                    <div className="error-label">{formik.errors.amount}</div>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="d-flex flex-column">
                  <label className="fs-6 mb-2">Quick Select</label>
                  <div className="d-flex gap-2 flex-wrap">
                    {[1000, 2000, 5000].map((amount) => (
                      <button
                        key={amount}
                        type="button"
                        className={`wallet-amount-chip ${
                          formik.values.amount === amount
                            ? "wallet-amount-chip-filled"
                            : "wallet-amount-chip-outline"
                        }`}
                        onClick={() => {
                          formik.setFieldValue("amount", amount);
                        }}
                      >
                        ₹ {amount?.toLocaleString("en-IN")}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex gap-3 mt-4">
              <button
                type="submit"
                className="fill-btn manage-btn"
                disabled={formik.isSubmitting}
              >
                {formik.isSubmitting ? "Processing..." : "Proceed to Pay"}
              </button>
              <button
                type="button"
                className="btn wallet-cancel-btn"
                onClick={() => {
                  formik.resetForm();
                }}
              >
                Clear
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddBalance;
